import {createContext,useContext} from 'react';
import type {Organization,Session} from '@rolling-ranch/ui';
export const WorkspaceContext=createContext<{organization:Organization;session:Session;canEdit:boolean;refreshSession:()=>Promise<unknown>}|null>(null);
export function useWorkspace(){const value=useContext(WorkspaceContext);if(!value)throw new Error('Workspace is not available');return value;}
